import React, { useEffect, useState } from 'react';
import { ProductComparisonProductVariant } from '../../../.storyblok/types/255103/storyblok-components';

interface HorizontalCarouselPillNavProps {
  onSlideChange: (index: number) => void;
  slides: ProductComparisonProductVariant[];
}

const HorizontalCarouselPillNav = ({ onSlideChange, slides }: HorizontalCarouselPillNavProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    onSlideChange(currentIndex);
  }, [currentIndex, onSlideChange]);

  const handleNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full mx-auto">
      <div className="overflow-hidden relative h-[180px] sm:h-[300px] md:h-[450px] lg:h-[600px]">
        {slides.map((slide, index) => (
          <div
            key={slide._uid}
            className={`absolute inset-0 transition-transform transform ${
            index === currentIndex ? 'translate-x-0' : 'translate-x-full' }`}
          >
            <img
              src={slide.image?.filename ?? ''}
              alt={slide.image?.alt ?? ''}
              className="w-full h-full object-cover rounded-[20px]"
              fetchPriority={index === 0 ? 'high' : undefined}
            />
          </div>
        ))}
      </div>
      <button
        aria-label="previous button"
        className="absolute top-0 left-0 h-full w-[25px] md:w-[45px] max-w-[45px] transform bg-transparent"
        onClick={handlePrevSlide}
      />
      <button
        aria-label="next button"
        className="absolute top-0 right-0 h-full w-[25px] md:w-[45px] max-w-[45px] transform bg-transparent"
        onClick={handleNextSlide}
      />
      <div className="absolute left-[30px] md:left-[50px] bottom-[20px] flex gap-x-[9px]">
        {slides.map((slide, index) => (
          <button
            aria-label={`navigation button for slide ${index + 1}`}
            className={`${
            index === currentIndex
                ? 'w-[17px] sm:w-[24px] md:w-[31px] rounded-[30px]'
                : 'w-[5px] sm:w-[7px] md:w-[9px] rounded-[50%]'
            } h-[5px] sm:h-[7px] md:h-[9px] bg-navy-600`}
            key={`nav_${slide._uid}`}
            onClick={() => {
              setCurrentIndex(index);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(HorizontalCarouselPillNav);
